export default {
  mounted(el, binding) {
    // Tambahkan class dasar untuk disembunyikan awalnya
    el.classList.add('reveal-hidden')
    
    // Optional delay via binding value (e.g. v-reveal="150" for 150ms delay)
    if (binding.value && typeof binding.value === 'number') {
      el.style.transitionDelay = `${binding.value}ms`
    }

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          el.classList.add('is-revealed')
          // Stop observing once revealed to only animate on scroll down
          observer.unobserve(el)
        }
      })
    }, {
      threshold: 0.1, // Element needs to be 10% visible
      rootMargin: '0px 0px -50px 0px' // Trigger slightly before it comes into view completely
    })

    observer.observe(el)
  }
}
